
import * as React from "react";
import { cn } from "@/lib/utils";
import { Input as BaseInput } from "@/components/ui/input";

interface CustomInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

const CustomInput = React.forwardRef<HTMLInputElement, CustomInputProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <BaseInput
        ref={ref}
        className={cn(
          error && "border-red-500 focus-visible:ring-red-500",
          className
        )}
        {...props}
      />
    );
  }
);

CustomInput.displayName = "CustomInput";

export { CustomInput };
